export const GROHE_CONFIG = {
  sidebarWidth: {
    desktop: 306.5,
    mobile: 360,
  },
  similarProductsWidth: {
    desktop: 307.5,
    // mobile: 360,
  },
  mainBarWidth: {
    desktop: 412,
  }
};
